import React from 'react';
import { useEffect, useState } from 'react';
import { Droppable } from 'react-beautiful-dnd';

/*
  Hack to get Drag/Drop working in Strict Mode.
  https://github.com/atlassian/react-beautiful-dnd/issues/2399
*/

export const StrictModeDroppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return <Droppable {...props}>{children}</Droppable>;
};
